import { render, staticRenderFns } from "./itemAttributes.vue?vue&type=template&id=b04f48c4&scoped=true"
import script from "./itemAttributes.vue?vue&type=script&lang=js"
export * from "./itemAttributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04f48c4",
  null
  
)

export default component.exports